


export enum CharacterTypeEnum {
	calm = 'Kliďas',
	wild = 'Divoch',
}


export const CHARACTER_TYPE_ENUM_TRANSLATION_KEYS = {
	[CharacterTypeEnum.calm]: 'animalInfo.character.characterTypeEnum.calm',
	[CharacterTypeEnum.wild]: 'animalInfo.character.characterTypeEnum.wild',
} as const;


export const isCharacterTypeEnum = (value: unknown): value is CharacterTypeEnum => {
	const enumValues = Object.values(CharacterTypeEnum);
	return typeof value === 'string' && enumValues.includes(value as CharacterTypeEnum);
};